import React from 'react';
import { useTranslation } from 'react-i18next';
import { Address, Button, Text } from '@dotcom/crown-ui';
import { AddressBoxProps } from './address-box-types';
import styles from './address-box.module.scss';

// AddressBox renders a stylized block of address information with an edit CTA.
export const AddressBox = ({ address, onEditAddress }: AddressBoxProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles['address-box']}>
      <Address {...address} addClass={styles.address} />
      <Button
        variant="secondary"
        testId="address-box-edit-button"
        className={styles['edit-button']}
        onClick={onEditAddress}
      >
        <Text as="span">{t('addressConfirmation.editAddress')}</Text>
      </Button>
    </div>
  );
};
